import { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import axiosInstance from 'services/axiosInstance';
import * as S from './styled';
//Components
import ActionButton from '../../../../Button/ActionButton';
import LayoutWithList from '../../../../LayoutModal/WithList';
import Loading from "../../../../Loading";
//hooks
import apiRequest from '../../../../../hooks/apiRequest';
import useLoading from '../../../../../hooks/useLoading';
//Interfaces
import { Inputs } from "Interfaces/ICategory";
import { ICreate } from 'Interfaces/ICreate';
export default function Update({
    isOpenModal,
    setModalClose,
    selectedUrlId,
    refreshFrames,

    setToastData,
    setToastOpen
}: ICreate) {

    const {
        register,
        handleSubmit: handleFormSubmit,
        setValue,
        formState: { errors },
    } = useForm<Inputs>();

    const { isLoading, startLoading, stopLoading } = useLoading();

    const fetchData = async () => {
        startLoading();
        try {
            const response = await axiosInstance.get(`category-expense/${selectedUrlId}`);
            const addressData = response.data;
            for (const key in addressData) {
                setValue(key as keyof Inputs, addressData[key]);
            }
        } catch (error) {
            console.log("Error: ", error);
        } finally {
            stopLoading();
        }
    };

    useEffect(() => {
        if (isOpenModal && selectedUrlId !== null) {
            fetchData();
        }
    }, [isOpenModal, selectedUrlId]);

    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        try {
            const formattedData = {
                category_expense: data.category_expense.toUpperCase(),
            };
            const response = await apiRequest(
                `category-expense/${selectedUrlId}`,
                "PUT",
                formattedData
            );
            const status = response.status;
            if (status === 200) {
                setToastData({
                    status: status,
                    message: 'Cadastrado com sucesso!',
                });

                setToastOpen(true);
                refreshFrames();
                setModalClose();
            }
        } catch (error: any) {
            setToastData({
                status: error?.response?.status || 500,
                message: error.message || 'Erro inesperado',
            });

            setToastOpen(true);
        }
    };

    if (isOpenModal) {
        return (
            <LayoutWithList
                title='Editar Categoria'
                subTitle='Atualize as informações do tipo em sua base de dados.'
                setModalClose={setModalClose}
            >
                <S.Container>
                    {
                        isLoading ? (
                            <Loading />
                        ) :
                            <S.SeparateDiv>
                                <S.FormInput>
                                    <S.Label>
                                        Nome da categoria
                                        <span>*</span>
                                    </S.Label>
                                    <S.Input
                                        placeholder="Informe o nome da categoria"
                                        type="text"
                                        {...register("category_expense", { required: true })}
                                    />
                                    {errors.category_expense && <S.InforErro>Campo Obrigatório</S.InforErro>}
                                </S.FormInput>

                                <S.ContentButton>
                                    <ActionButton name='Atualizar' onClick={handleFormSubmit(onSubmit)} />
                                </S.ContentButton>
                            </S.SeparateDiv>
                    }
                </S.Container>
            </LayoutWithList>
        )
    } return null
}